module.exports = __webpack_public_path__ + "static/media/explore.589a6e5f.jpeg";